export var LevelLength;
(function (LevelLength) {
    LevelLength[LevelLength["TINY"] = 1] = "TINY";
    LevelLength[LevelLength["SHORT"] = 2] = "SHORT";
    LevelLength[LevelLength["MEDIUM"] = 3] = "MEDIUM";
    LevelLength[LevelLength["LONG"] = 4] = "LONG";
    LevelLength[LevelLength["XL"] = 5] = "XL";
    LevelLength[LevelLength["PLATFORMER"] = 6] = "PLATFORMER";
})(LevelLength || (LevelLength = {}));
